import DetailsIcon from './DetailsIconTS';
import DownloadIcon from './DownloadIconTS';
import BaseNodeIcon from './BaseNodeIcon';
import NodeLevelsIcon from './NodeLevelsIcon';
import EditIcon from './EditIconTS';
import LogsIcon from './LogsIconTS';
import AccelerateIcon from './AccelerateIconTS';
import DeActivateIcon from './DeActivateIconTS';
import NodeImagesIcon from './NodeImagesIcon';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import React from 'react';
import { connect } from 'react-redux';
import { setCurrentNodeID } from '../../stores/actions/actions';
import { accelerateNode } from '../../stores/actions/nodeActions';
import { INode, ISystem } from '../../helpers/interfaces';

interface INodeActionIconsProps {
	currentNodeId: number;
	isEditing: boolean;
	nodes: INode[];
	systems: ISystem[];
	disabledDownloadIcons: number[];
	node: INode;
	showEditIcon: boolean;
	showBaseNodeIcon: boolean;
	showDetailsIcon: boolean;
	showLogsIcon: boolean;
	showDownloadIcon: boolean;
	showAccelerateIcon: boolean;
	showLevelsIcon: boolean;
	showDeActivateIcon: boolean;
	showNodeImagesIcon: boolean;
	system: ISystem;
	accountCategory: string;
	mobileView: boolean;
	showBaseCard: (node: INode) => void;
	showLevelsCard: (node: INode) => void;
	showEditNodeNameCard: (node: INode) => void;
	showAccelerateCard: (node: INode) => void;
	showDeActivateCard: (node: INode) => void;
	showNodeImagesCard: (node: INode) => void;
	setCurrentNodeID: (nodeId: number) => void;
	showExportCard: (node: INode, system: ISystem) => void;
	accelerateNode: (nodeID: number, updatedViaWebsiteAt: string, acceleratedUntil: string) => void;
	deActivateNode: (nodeID: number, active: boolean) => void;

}

class NodeActionIcons extends React.Component<INodeActionIconsProps> {
	setCurrentNodeId = (nodeID: number): void => {
		this.props.setCurrentNodeID(nodeID);
	};

	render() {
		const {
			isEditing,
			node,
			showBaseNodeIcon,
			showEditIcon,
			showDetailsIcon,
			showLogsIcon,
			showDownloadIcon,
			showAccelerateIcon,
			showDeActivateIcon,
			showNodeImagesIcon,
			showExportCard,
			system,
			showEditNodeNameCard,
			showBaseCard,
			showLevelsCard,
			disabledDownloadIcons,
			showAccelerateCard,
			showDeActivateCard,
			showNodeImagesCard,
			accelerateNode,
			deActivateNode
		} = this.props;
		const iconsRowStyle = {
			display: 'flex',
			justifyContent: 'flex-start',
			alignItems: 'center',
			flexDirection: 'row',
			overflow: 'auto'
		};

		return (
			<GridContainer style={{flexBasis: "fit-content", maxWidth: "100%"}}>
				<GridItem xs={12} style={iconsRowStyle} data-testid='nodeActionIcons'>
                    <LogsIcon
                        nodeId={node.id}
                        systemId={system.ID}
                        show={showLogsIcon}
                    />
                    <NodeLevelsIcon
                        node={node}
                        show={showBaseNodeIcon}
                        showNodeLevelsCard={showLevelsCard}
                    />
                    <BaseNodeIcon
                        isEditing={isEditing}
                        node={node}
                        show={showBaseNodeIcon}
                        showBaseCard={showBaseCard}
                    />
                    <EditIcon
                        node={node}
                        show={showEditIcon}
                        showEditNodeNameCard={showEditNodeNameCard}
                    />
                    <DetailsIcon
                        node={node}
                        show={showDetailsIcon}
                    />
                    <DownloadIcon
                        show={showDownloadIcon}
                        showExportCard={showExportCard}
                        system={system}
                        node={node}
                        disabledDownloadIcons={disabledDownloadIcons}
                    />
                    <AccelerateIcon
                        node={node}
                        show={showAccelerateIcon}
						accelerateNode={accelerateNode}
                        showAccelerateCard={showAccelerateCard}
                    />
					<DeActivateIcon
                        node={node}
                        show={showDeActivateIcon}
                        showDeActivateCard={showDeActivateCard}
                    />
					<NodeImagesIcon
                        node={node}
                        show={showNodeImagesIcon}
                        showNodeImagesCard={showNodeImagesCard}
                    />
				</GridItem>
			</GridContainer>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		currentNodeId: state.dashboard.currentNodeId,
		isEditing: state.dashboard.isEditing,
		nodes: state.dashboard.nodes,
		systems: state.dashboard.systems,
		disabledDownloadIcons: state.dashboard.disabledDownloadIcons,
		accountCategory: state.login.accountCategory,
	};
};

const actions = { setCurrentNodeID, accelerateNode };

export default connect(mapStateToProps, actions)(NodeActionIcons);
